export default __webpack_public_path__ + "static/DigitalOceanOffice-b138ba8aeca7ee6cd3e86d6cc07f62d9.png";